import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import FuelChart from "../../../containers/pages/fuel-chart";
class PagesFuelChart extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.fuel-chart" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <FuelChart />
      </Fragment>
    );
  }
}

export default PagesFuelChart;
